module.exports = __webpack_public_path__ + "img/icon-历史@2x.2e83cf9f.png";